(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["animation-brosse"] && !Shopify.designMode) return;
  try {
    
if(!customElements.get('fz-brush-animation')){
  class FzBrushAnimation extends HTMLElement{
    connectedCallback(){
      if(this.initialized)return;
      this.initialized=true;
      this.video=this.querySelector('video');
      this.button=this.querySelector('[data-motion-toggle]');
      this.buttonLabel=this.querySelector('[data-motion-label]');
      this.playIcon=this.querySelector('[data-motion-play]');
      this.pauseIcon=this.querySelector('[data-motion-pause]');
      this.range=this.querySelector('[data-comparison-range]');
      this.comparison=this.querySelector('[data-comparison]');
      this.motion=window.matchMedia('(prefers-reduced-motion: reduce)');
      this.userPaused=this.dataset.autoplay!=='true'||this.motion.matches;
      this.inView=false;
      this.running=false;
      this.playVersion=0;
      this.toggleMotion=()=>{this.userPaused=!this.userPaused;this.dataset.userMotion=String(!this.userPaused);this.sync();};
      this.visibilityChanged=()=>this.sync();
      this.motionChanged=()=>{if(this.motion.matches){this.userPaused=true;this.dataset.userMotion='false';}this.sync();};
      this.rangeChanged=()=>this.comparison?.style.setProperty('--bz-pos',this.range.value+'%');
      this.videoPaused=()=>{if(this.running&&!this.video.ended){this.userPaused=true;this.sync();}};
      this.videoPlayed=()=>{if(!this.inView||document.hidden){this.video.pause();return;}if(this.userPaused){this.userPaused=false;this.dataset.userMotion='true';this.sync();}};
      this.videoFailed=()=>{this.video.pause();this.video.hidden=true;const fallback=this.querySelector('[data-media-fallback]');if(fallback)fallback.hidden=false;this.sync();};
      this.button?.addEventListener('click',this.toggleMotion);
      this.range?.addEventListener('input',this.rangeChanged);
      document.addEventListener('visibilitychange',this.visibilityChanged);
      this.motion.addEventListener('change',this.motionChanged);
      if(this.video){this.video.muted=true;this.video.defaultMuted=true;this.video.addEventListener('pause',this.videoPaused);this.video.addEventListener('play',this.videoPlayed);this.video.addEventListener('error',this.videoFailed,true);}
      if('IntersectionObserver'in window){this.observer=new IntersectionObserver(entries=>{this.inView=entries[0].isIntersecting;this.sync();},{threshold:0.05});this.observer.observe(this);}else{this.inView=true;}
      this.dataset.enhanced='true';
      if(this.button)this.button.hidden=false;
      this.sync();
    }
    sync(){
      if(!this.initialized)return;
      this.running=this.inView&&!document.hidden&&!this.userPaused;
      this.dataset.running=String(this.running);
      if(this.buttonLabel)this.buttonLabel.textContent=this.running?this.dataset.pauseLabel:this.dataset.playLabel;
      if(this.playIcon)this.playIcon.toggleAttribute('hidden',this.running);
      if(this.pauseIcon)this.pauseIcon.toggleAttribute('hidden',!this.running);
      const version=++this.playVersion;
      if(!this.video||this.video.hidden)return;
      if(this.running){
        this.video.muted=true;
        if(this.video.paused){const playback=this.video.play();playback?.catch(()=>{if(this.initialized&&this.running&&this.playVersion===version){this.userPaused=true;this.sync();}});}
      }else this.video.pause();
    }
    disconnectedCallback(){
      this.initialized=false;
      this.running=false;
      this.dataset.running='false';
      this.playVersion++;
      this.observer?.disconnect();
      document.removeEventListener('visibilitychange',this.visibilityChanged);
      this.motion?.removeEventListener('change',this.motionChanged);
      this.button?.removeEventListener('click',this.toggleMotion);
      this.range?.removeEventListener('input',this.rangeChanged);
      if(this.video){this.video.removeEventListener('pause',this.videoPaused);this.video.removeEventListener('play',this.videoPlayed);this.video.removeEventListener('error',this.videoFailed,true);this.video.pause();}
    }
  }
  customElements.define('fz-brush-animation',FzBrushAnimation);
}

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["fz-system"]) return;
  try {
    
class FzProduct extends HTMLElement {
  connectedCallback(){
    if(this.ready)return;
    this.ready=true;
    this.form=this.querySelector('.fz-product-form');
    this.gallery=this.querySelector('.fz-gallery');
    this.video=this.querySelector('video');
    this.image=this.querySelector('.fz-gallery-image');
    this.querySelectorAll('[data-image]').forEach(button=>button.addEventListener('click',()=>this.showImage(button.dataset.image,button)));
    this.querySelector('[data-show-video]')?.addEventListener('click',event=>{this.image.hidden=true;this.video.hidden=false;this.gallery.querySelectorAll('[aria-pressed]').forEach(b=>b.setAttribute('aria-pressed',String(b===event.currentTarget)));this.video.play().catch(()=>{});});
    if(!this.form)return;
    this.variants=JSON.parse(this.querySelector('[data-variants]').textContent);
    this.words=JSON.parse(this.querySelector('[data-product-strings]').textContent);
    this.currency=this.dataset.currency||'EUR';
    this.form.addEventListener('change',()=>this.updateStickyPack());
    this.updateStickyPack();
    this.money=n=>new Intl.NumberFormat('fr-FR',{style:'currency',currency:this.currency}).format(n/100);
    this.add=this.form.querySelector('[type=submit]');
    this.error=this.querySelector('.fz-form-error');
    this.sticky=this.querySelector('.fz-sticky-buy');
    this.form.querySelectorAll('[name^="fz-pack-"],[name^="fz-colour-"]').forEach(r=>r.addEventListener('change',()=>this.sync(true)));
    this.form.addEventListener('submit',event=>{event.preventDefault();this.addItem();});
    this.querySelector('[data-sticky-add]')?.addEventListener('click',()=>this.addItem());
    this.sync(false);
    if(this.sticky){this.observer=new IntersectionObserver(entries=>{this.sticky.hidden=entries[0].isIntersecting;},{threshold:0});this.observer.observe(this.add);}
    
  }
  updateStickyPack(){const target=this.querySelector('[data-sticky-pack]');const pack=this.form?.querySelector('[name^="fz-pack-"]:checked');if(target&&pack)target.textContent=this.words.packs[parseInt(pack.value,10)-1]||this.words.title;}
  disconnectedCallback(){this.observer?.disconnect();this.videoObserver?.disconnect();}
  showImage(url,button){if(this.video){this.video.pause();this.video.hidden=true;}this.image.src=url;this.image.alt=this.querySelector('[data-colour-name]')?.textContent||this.words?.title||'FurZap';this.image.hidden=false;this.gallery.querySelectorAll('[aria-pressed]').forEach(b=>b.setAttribute('aria-pressed',String(b===button)));}
  sync(changed){
    const pack=this.form.querySelector('[name^="fz-pack-"]:checked')?.value;
    const colour=this.form.querySelector('[name^="fz-colour-"]:checked')?.value;
    const v=this.variants.find(v=>v.option1===pack&&v.option2===colour);
    if(!v)return;
    this.variant=v;
    this.form.querySelector('[name=id]').value=v.id;
    this.querySelector('[data-colour-name]').textContent=colour==='Blush Pink'?this.words.pink:this.words.blue;
    this.querySelector('[data-selected-price]').textContent=this.money(v.price);
    this.querySelector('[data-sticky-price]').textContent=this.money(v.price);
    const single=this.variants.find(x=>x.option1==='1 brush'&&x.option2===colour);
    const count=parseInt(pack,10);
    const saving=single?single.price*count-v.price:0;
    this.querySelector('[data-selected-saving]').textContent=saving>0?`${this.words.saving} ${this.money(saving)}`:'';
    this.querySelectorAll('[data-pack-saving]').forEach(el=>{const n=Number(el.dataset.packSaving),opt=this.variants.find(x=>parseInt(x.option1,10)===n&&x.option2===colour);if(opt){el.parentElement.querySelector('strong').textContent=this.money(opt.price);el.parentElement.querySelector('[data-pack-each]').textContent=`${this.money(Math.round(opt.price/n))} ${this.words.each}`;el.textContent=n>1&&single&&single.price*n>opt.price?`${this.words.saving} ${this.money(single.price*n-opt.price)}`:'';}});
    this.add.disabled=!v.available;
    this.querySelector('[data-add-label]').textContent=v.available?this.words.add:this.words.sold;
    this.querySelector('[data-sticky-add]').disabled=!v.available;
    const imageUrl=colour==='Blush Pink'?'https://cdn.shopify.com/s/files/1/1022/8095/4182/files/furzap-pink.jpg?v=1789575627':'https://cdn.shopify.com/s/files/1/1022/8095/4182/files/furzap-blue.jpg?v=1789575643';
    this.sticky.querySelector('img').src=imageUrl;
    if(changed){const url=new URL(window.location.href);if(url.pathname.includes('/products/')){url.searchParams.set('variant',v.id);history.replaceState(null,'',url);}this.showImage(imageUrl,this.gallery.querySelector(`[data-image="${imageUrl}"]`));}
  }
  async addItem(){
    if(this.busy||!this.variant?.available)return;
    this.busy=true;this.add.disabled=true;this.error.hidden=true;this.querySelector('[data-add-label]').textContent=this.words.loading;
    try{const response=await fetch(`${this.dataset.root}cart/add.js`,{method:'POST',headers:{'Content-Type':'application/json','Accept':'application/json'},body:JSON.stringify({items:[{id:this.variant.id,quantity:1}]})});const data=await response.json();if(!response.ok)throw new Error(data.description||this.words.error);document.dispatchEvent(new CustomEvent('fz:cart-open'));}
    catch(error){this.error.textContent=error.message||this.words.error;this.error.hidden=false;}
    finally{this.busy=false;this.add.disabled=!this.variant.available;this.querySelector('[data-add-label]').textContent=this.words.add;}
  }
}
class FzCart extends HTMLElement {
  connectedCallback(){
    if(this.ready)return;this.ready=true;
    this.dialog=this.querySelector('dialog');this.items=this.querySelector('.fz-cart-items');this.foot=this.querySelector('.fz-cart-foot');this.error=this.querySelector('.fz-cart-error');this.words=JSON.parse(this.querySelector('[data-cart-strings]').textContent);
    this.upsells=JSON.parse(this.querySelector('[data-upsell-variants]').textContent)||[];
    this.openHandler=()=>this.open();document.addEventListener('fz:cart-open',this.openHandler);
    this.clickHandler=event=>{if(event.target.closest('[data-cart-open]'))this.open();};document.addEventListener('click',this.clickHandler);
    this.querySelectorAll('[data-cart-close]').forEach(b=>b.addEventListener('click',()=>this.dialog.close()));
    this.dialog.addEventListener('click',event=>{if(event.target===this.dialog){const r=this.dialog.getBoundingClientRect();if(event.clientX<r.left||event.clientX>r.right)this.dialog.close();}});
    this.items.addEventListener('change',event=>{if(event.target.matches('[data-line-key]'))this.change(event.target.dataset.lineKey,Number(event.target.value));});
    this.items.addEventListener('click',event=>{const upgrade=event.target.closest('[data-upgrade-key]');if(upgrade){this.upgrade(upgrade.dataset.upgradeKey);return;}const button=event.target.closest('[data-remove-key]');if(button)this.change(button.dataset.removeKey,0);});
  }
  disconnectedCallback(){document.removeEventListener('fz:cart-open',this.openHandler);document.removeEventListener('click',this.clickHandler);}
  esc(value){return String(value??'').replace(/[&<>"']/g,c=>({'&':'&amp;','<':'&lt;','>':'&gt;','"':'&quot;',"'":'&#39;'}[c]));}
  async open(){if(!this.dialog.open)this.dialog.showModal();await this.refresh();}
  async refresh(){this.error.hidden=true;try{const response=await fetch(`${this.dataset.root}cart.js`,{headers:{Accept:'application/json'}});if(!response.ok)throw new Error(this.words.error);this.render(await response.json());}catch(error){this.error.textContent=this.words.error;this.error.hidden=false;}}
  render(cart){
    this.cart=cart;
    this.currency=cart.currency||this.dataset.currency||'EUR';const money=n=>new Intl.NumberFormat('fr-FR',{style:'currency',currency:this.currency}).format(n/100);document.querySelectorAll('[data-cart-count]').forEach(el=>el.textContent=cart.item_count);this.foot.hidden=!cart.item_count;
    if(!cart.item_count){this.items.innerHTML=`<div class="fz-cart-empty"><p>${this.esc(this.words.empty)}</p><a class="fz-button" href="${this.dataset.root}products/furzap-self-cleaning-pet-hair-brush">${this.esc(this.words.shop)} ↗</a></div>`;return;}
    this.items.innerHTML=cart.items.map(item=>{
      const isFurZap=Number(item.product_id)===15732891287878;
      const title=isFurZap?this.words.product:item.product_title;
      const variant=isFurZap?(this.words.packs[parseInt(item.variant_title,10)-1]||this.words.product)+' / '+(item.variant_title.includes('Blush Pink')?this.words.pink:/(White|Blanc)/.test(item.variant_title)?this.words.white:this.words.blue):item.variant_title;
      return `<article class="fz-cart-item">${item.image?`<img src="${this.esc(item.image)}" width="75" height="85" alt="${this.esc(title)}">`:''}<div><h3>${this.esc(title)}</h3><p>${this.esc(variant)}</p><div class="fz-cart-item-footer"><label>${this.esc(this.words.quantity)}<input aria-label="${this.esc(this.words.quantity+' '+variant)}" type="number" min="0" max="99" value="${item.quantity}" data-line-key="${this.esc(item.key)}"></label><strong>${money(item.final_line_price)}</strong></div><button type="button" class="fz-cart-remove" data-remove-key="${this.esc(item.key)}">${this.esc(this.words.remove)}</button></div></article>`;
    }).join('');this.querySelector('[data-cart-total]').textContent=money(cart.total_price);
    cart.items.forEach(item=>{const next=this.nextPack(item);if(!next)return;const row=Array.from(this.items.querySelectorAll('[data-remove-key]')).find(button=>button.dataset.removeKey===item.key);const offer=this.promoOffer(item,next);const label=offer?`${this.esc(this.words.offer_one)} ${money(990)} ↗<small>${this.esc(this.words.offer_detail)}</small>`:`${this.esc(this.words.upgrade)} ${this.esc(this.words.packs[parseInt(next.option1,10)-1])} · ${money(next.price-item.final_price)} ${this.esc(this.words.extra)} ↗`;if(row)row.insertAdjacentHTML('afterend',`<button type="button" class="fz-upgrade-button" data-upgrade-key="${this.esc(item.key)}">${label}</button>`);});
  }
  nextPack(item){
    if(!item||item.quantity!==1||item.selling_plan_allocation||Object.keys(item.properties||{}).length||this.currency!==this.dataset.currency)return;
    const current=this.upsells.find(v=>Number(v.id)===Number(item.variant_id));
    if(!current||item.final_price!==current.price)return;
    return this.upsells.find(v=>v.available&&v.option2===current.option2&&parseInt(v.option1,10)===parseInt(current.option1,10)+1&&v.price>current.price&&!this.cart.items.some(i=>Number(i.variant_id)===Number(v.id)));
  }
  discountCodes(cart=this.cart){
    const codes=(cart?.discount_codes||[]).map(x=>typeof x==='string'?x:x.code);
    const allocations=[...(cart?.cart_level_discount_applications||[]),...(cart?.items||[]).flatMap(x=>(x.line_level_discount_allocations||[]).map(a=>a.discount_application))];
    allocations.forEach(x=>{if(x?.type==='discount_code')codes.push(x.title);});
    return [...new Set(codes.filter(Boolean))];
  }
  promoOffer(item,next){
    if(!next||this.currency!=='EUR'||item.quantity!==1||item.final_price!==2990||next.price!==3990||parseInt(next.option1,10)!==3||Number(this.cart?.total_discount||0)!==0||this.discountCodes().length)return false;
    if(this.cart.items.some(i=>i.key!==item.key&&(Number(i.variant_id)===Number(item.variant_id)||this.upsells.some(v=>Number(v.id)===Number(i.variant_id)&&parseInt(v.option1,10)===3))))return false;
    return true;
  }
  async postCart(payload){
    const response=await fetch(`${this.dataset.root}cart/update.js`,{method:'POST',headers:{'Content-Type':'application/json','Accept':'application/json'},body:JSON.stringify(payload)});
    const data=await response.json();if(!response.ok)throw new Error(data.description||this.words.error);return data;
  }
  async upgrade(key){
    if(this.busy)return;
    let item=this.cart?.items.find(i=>i.key===key),next=this.nextPack(item);if(!next)return;
    const wasOffer=this.promoOffer(item,next);
    this.busy=true;this.error.hidden=true;this.items.querySelectorAll('button,input').forEach(x=>x.disabled=true);this.foot?.querySelectorAll('button[name=checkout]').forEach(x=>x.disabled=true);
    try{
      const fresh=await fetch(`${this.dataset.root}cart.js`,{headers:{Accept:'application/json'}});if(!fresh.ok)throw new Error(this.words.error);
      this.cart=await fresh.json();this.currency=this.cart.currency||this.dataset.currency;
      item=this.cart.items.find(i=>i.key===key);next=this.nextPack(item);
      if(!next||wasOffer&&!this.promoOffer(item,next))throw new Error(this.words.offer_error||this.words.error);
      const before=this.cart.total_price,payload={updates:{[key]:0,[next.id]:1}};
      if(wasOffer)payload.discount='FZPLUS1-990';
      const data=await this.postCart(payload);
      if(wasOffer){
        const added=data.items.find(i=>Number(i.variant_id)===Number(next.id));
        if(!added||added.quantity!==1||added.final_line_price!==3980||Number(data.total_discount)!==10||data.total_price-before!==990){
          if(added&&added.quantity===1&&!data.items.some(i=>Number(i.variant_id)===Number(item.variant_id))){
            const codes=this.discountCodes(data).filter(code=>code.toUpperCase()!=='FZPLUS1-990');
            const restored=await this.postCart({updates:{[added.key]:0,[item.variant_id]:1},discount:codes.join(',')});this.render(restored);
          }else this.render(data);
          throw new Error(this.words.offer_error||this.words.error);
        }
      }
      this.render(data);
    }catch(error){await this.refresh();this.error.textContent=error.message;this.error.hidden=false;}finally{this.busy=false;this.items.querySelectorAll('button,input').forEach(x=>x.disabled=false);this.foot?.querySelectorAll('button[name=checkout]').forEach(x=>x.disabled=false);}
  }
  async change(key,quantity){
    if(this.busy||!Number.isInteger(quantity)||quantity<0)return;
    this.busy=true;this.error.hidden=true;this.items.querySelectorAll('button,input').forEach(x=>x.disabled=true);this.foot?.querySelectorAll('button[name=checkout]').forEach(x=>x.disabled=true);
    try{const response=await fetch(`${this.dataset.root}cart/change.js`,{method:'POST',headers:{'Content-Type':'application/json','Accept':'application/json'},body:JSON.stringify({id:key,quantity})});const data=await response.json();if(!response.ok)throw new Error(data.description||this.words.error);this.render(data);}catch(error){await this.refresh();this.error.textContent=error.message;this.error.hidden=false;}finally{this.busy=false;this.items.querySelectorAll('button,input').forEach(x=>x.disabled=false);this.foot?.querySelectorAll('button[name=checkout]').forEach(x=>x.disabled=false);}
  }
}
document.querySelectorAll('[data-hero-pause]').forEach(button=>{const video=button.parentElement.querySelector('video');if(!video)return;const sync=()=>{const path=video.paused?'m9 5 10 7-10 7Z':'M9 5v14m6-14v14';button.innerHTML='<svg width="20" height="20" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="1.5" aria-hidden="true"><path d="'+path+'"/></svg>';button.setAttribute('aria-label',video.paused?button.dataset.playLabel:button.dataset.pauseLabel);};video.addEventListener('play',sync);video.addEventListener('pause',sync);video.addEventListener('error',sync);if(matchMedia('(prefers-reduced-motion: reduce)').matches){video.autoplay=false;video.pause();}button.addEventListener('click',()=>{if(video.paused){video.play().catch(sync);}else{video.pause();}});sync();});
document.querySelectorAll('.fz-mobile-menu').forEach(menu=>{menu.addEventListener('click',event=>{if(event.target.closest('a'))menu.open=false;});document.addEventListener('click',event=>{if(menu.open&&!menu.contains(event.target))menu.open=false;});document.addEventListener('keydown',event=>{if(event.key==='Escape'&&menu.open){menu.open=false;menu.querySelector('summary').focus();}});});
if(!customElements.get('fz-product'))customElements.define('fz-product',FzProduct);
if(!customElements.get('fz-cart'))customElements.define('fz-cart',FzCart);

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["main-collection"]) return;
  try {
    
  const url = new URL(window.location.href);
  if (url.hash) {
    document.addEventListener(
      'DOMContentLoaded',
      () => {
        const card = document.getElementById(url.hash.slice(1));
        if (card) {
          card.scrollIntoView({ behavior: 'instant' });
        }
      },
      { once: true }
    );
  }

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["page-produit-premium"] && !Shopify.designMode) return;
  try {
    
class FzPremiumProduct extends HTMLElement {
  connectedCallback() {
    if (this.ready) return;
    this.form = this.querySelector('.pp__form');
    if (!this.form) return;
    this.variants = JSON.parse(this.querySelector('[data-variants]').textContent);
    this.words = JSON.parse(this.querySelector('[data-words]').textContent);
    this.controller = new AbortController();
    this.listen = (element, event, handler) => element?.addEventListener(event, handler, { signal: this.controller.signal });
    this.money = value => new Intl.NumberFormat(this.dataset.locale || 'fr-FR', { style: 'currency', currency: this.dataset.currency || 'EUR' }).format(value / 100);
    this.packInputs = Array.from(this.querySelectorAll('[data-pack]'));
    this.colourInputs = Array.from(this.querySelectorAll('[data-colour]'));
    this.idInput = this.querySelector('[data-variant-input]');
    this.mainAdd = this.querySelector('[data-atc]');
    this.stickyAdd = this.querySelector('[data-sticky-add]');
    this.sticky = this.querySelector('[data-sticky]');
    this.error = this.querySelector('[data-error]');
    this.track = this.querySelector('[data-track]');
    this.slides = Array.from(this.querySelectorAll('[data-slide]'));
    this.thumbs = Array.from(this.querySelectorAll('[data-thumb]'));
    this.video = this.querySelector('video');
    this.dialog = this.querySelector('[data-zoom-dialog]');
    this.reducedMotion = matchMedia('(prefers-reduced-motion: reduce)');
    const initial = this.variants.find(variant => String(variant.id) === this.dataset.initialVariant);
    if (initial) {
      this.packInputs.forEach(input => { input.checked = input.value === initial.option1; });
      this.colourInputs.forEach(input => { input.checked = input.value === initial.option2; });
    }
    this.packInputs.concat(this.colourInputs).forEach(input => this.listen(input, 'change', () => this.sync(true)));
    this.listen(this.form, 'submit', event => { event.preventDefault(); this.addItem(); });
    this.listen(this.querySelector('[data-prev]'), 'click', () => this.goTo(this.index - 1));
    this.listen(this.querySelector('[data-next]'), 'click', () => this.goTo(this.index + 1));
    this.thumbs.forEach(thumb => this.listen(thumb, 'click', () => this.goTo(Number(thumb.dataset.thumb))));
    this.listen(this.track, 'scroll', () => {
      cancelAnimationFrame(this.scrollFrame);
      this.scrollFrame = requestAnimationFrame(() => this.updateGallery());
    });
    this.listen(this.track, 'keydown', event => {
      if (event.target !== this.track) return;
      if (event.key === 'ArrowRight' || event.key === 'ArrowLeft') {
        event.preventDefault();
        this.goTo(this.index + (event.key === 'ArrowRight' ? 1 : -1));
      }
    });
    this.querySelectorAll('[data-zoom]').forEach(link => this.listen(link, 'click', event => {
      if (!this.dialog.showModal || event.ctrlKey || event.metaKey || event.shiftKey || event.altKey) return;
      event.preventDefault();
      this.zoomTrigger = link;
      const image = new Image();
      image.src = link.href;
      image.alt = link.querySelector('img')?.alt || this.words.imageAlt;
      this.querySelector('[data-zoom-image]').replaceChildren(image);
      this.video?.pause();
      this.dialog.showModal();
    }));
    this.listen(this.querySelector('[data-zoom-close]'), 'click', () => this.dialog.close());
    this.listen(this.dialog, 'close', () => this.zoomTrigger?.focus({ preventScroll: true }));
    this.listen(this.dialog, 'click', event => {
      if (event.target !== this.dialog) return;
      const rect = this.dialog.getBoundingClientRect();
      if (event.clientX < rect.left || event.clientX > rect.right || event.clientY < rect.top || event.clientY > rect.bottom) this.dialog.close();
    });
    this.listen(document, 'visibilitychange', () => { if (document.hidden) this.video?.pause(); });
    this.listen(window, 'resize', () => this.goTo(this.index, false));
    this.sync(false);
    this.updateGallery();
    this.classList.add('pp--ready');
    if ('IntersectionObserver' in window) {
      this.buyObserver = new IntersectionObserver(entries => { this.sticky.hidden = entries[0].isIntersecting; }, { threshold: 0.1 });
      this.buyObserver.observe(this.mainAdd);
      this.videoObserver = new IntersectionObserver(entries => { if (!entries[0].isIntersecting) this.video?.pause(); }, { threshold: 0.15 });
      this.videoObserver.observe(this.video);
    }
    this.ready = true;
  }
  disconnectedCallback() {
    this.controller?.abort();
    this.buyObserver?.disconnect();
    this.videoObserver?.disconnect();
    this.video?.pause();
    cancelAnimationFrame(this.scrollFrame);
    this.ready = false;
  }
  packCount(value) {
    return { '2 brushes': 2, '2 brosses': 2, 'duo pack': 2, '3 brushes': 3, '3 brosses': 3, 'trio pack': 3, '4 brushes': 4, '4 brosses': 4, '5 brushes': 5, '5 brosses': 5 }[String(value || '').trim().toLowerCase()] || 0;
  }
  packLabel(value) { return this.words.packs[this.packCount(value) - 1] || value || ''; }
  colourLabel(value) { return value === 'Powder Blue' ? this.words.blue : value === 'Blush Pink' ? this.words.pink : ['White','Blanc'].includes(value) ? this.words.white : value || ''; }
  findVariant(pack, colour) { return this.variants.find(variant => variant.option1 === pack && variant.option2 === colour); }
  setText(selector, value) { const element = this.querySelector(selector); if (element) element.textContent = value; }
  sync(changed) {
    const pack = this.packInputs.find(input => input.checked)?.value;
    const colour = this.colourInputs.find(input => input.checked)?.value;
    this.variant = this.findVariant(pack, colour);
    const duo = this.variants.find(variant => this.packCount(variant.option1) === 2 && variant.option2 === colour);
    this.idInput.value = this.variant ? String(this.variant.id) : '';
    this.idInput.disabled = !this.variant;
    this.packInputs.forEach(input => {
      const variant = this.findVariant(input.value, colour);
      const count = this.packCount(input.value);
      const card = input.closest('[data-pack-card]');
      const saving = variant && duo && count > 2 ? Math.max(0, Math.round(duo.price * count / 2 - variant.price)) : 0;
      input.disabled = this.busy || !variant?.available;
      card.querySelector('[data-pack-price]').textContent = variant ? this.money(variant.price) : '';
      card.querySelector('[data-pack-unit]').textContent = variant && count ? `${this.money(Math.round(variant.price / count))} ${this.words.each}` : '';
      card.querySelector('[data-pack-saving]').textContent = saving > 0 ? `${this.words.saving} ${this.money(saving)} ${this.words.vsDuo}` : '';
      card.querySelector('[data-pack-saving]').hidden = saving <= 0;
      card.querySelector('[data-pack-stock]').textContent = variant ? this.words.sold : this.words.unavailable;
      card.querySelector('[data-pack-stock]').hidden = Boolean(variant?.available);
    });
    this.colourInputs.forEach(input => {
      const variant = this.findVariant(pack, input.value);
      input.disabled = this.busy || !variant?.available;
      input.closest('.pp__colour-choice').querySelector('[data-colour-stock]').hidden = Boolean(variant?.available);
    });
    const count = this.packCount(pack);
    const saving = this.variant && duo && count > 2 ? Math.max(0, Math.round(duo.price * count / 2 - this.variant.price)) : 0;
    this.setText('[data-selected-price]', this.variant ? this.money(this.variant.price) : this.words.unavailable);
    this.setText('[data-selected-saving]', saving > 0 ? `${this.words.saving} ${this.money(saving)} ${this.words.vsDuo}` : '');
    this.setText('[data-selection-label]', `${this.packLabel(pack)} · ${this.colourLabel(colour)}`);
    this.setText('[data-sticky-pack]', this.packLabel(pack));
    this.setText('[data-sticky-colour]', this.colourLabel(colour));
    this.setText('[data-sticky-price]', this.variant ? this.money(this.variant.price) : '');
    this.updateButtons();
    if (changed) {
      this.idInput.dispatchEvent(new Event('change', { bubbles: true }));
      this.error.hidden = true;
      this.setText('[data-cart-status]', '');
      const url = new URL(window.location.href);
      if (this.variant) url.searchParams.set('variant', this.variant.id);
      else url.searchParams.delete('variant');
      history.replaceState(null, '', url);
      this.updateImage();
    }
  }
  updateButtons() {
    const unavailable = !this.variant?.available;
    this.mainAdd.disabled = this.busy || unavailable;
    this.stickyAdd.disabled = this.busy || unavailable;
    this.form.setAttribute('aria-busy', String(Boolean(this.busy)));
    const express = this.querySelector('.pp__express');
    if (express) express.hidden = this.busy || unavailable;
    this.setText('[data-add-label]', this.busy ? this.words.loading : unavailable ? this.words.sold : this.words.add);
    this.setText('[data-sticky-label]', this.busy ? this.words.loading : unavailable ? this.words.sold : this.words.addShort);
    this.stickyAdd.setAttribute('aria-label', `${this.busy ? this.words.loading : unavailable ? this.words.sold : this.words.add} · ${this.packLabel(this.variant?.option1)} · ${this.colourLabel(this.variant?.option2)}${this.variant ? ` · ${this.money(this.variant.price)}` : ''}`);
  }
  updateImage() {
    const source = this.variant?.featured_image?.src;
    if (!source) return;
    const link = this.querySelector('[data-featured-zoom]');
    if (!link) return;
    const image = link.querySelector('img');
    const full = new URL(source, document.baseURI);
    full.searchParams.set('width', '2400');
    link.href = full.href;
    const normal = new URL(source, document.baseURI);
    normal.searchParams.set('width', '1400');
    image.src = normal.href;
    image.removeAttribute('srcset');
    image.alt = `${this.words.imageAlt} · ${this.colourLabel(this.variant.option2)}`;
    const thumb = this.querySelector('[data-featured-thumb] img');
    const stickyImage = this.querySelector('.pp__sticky-img');
    normal.searchParams.set('width', '140');
    [thumb, stickyImage].filter(Boolean).forEach(item => { item.src = normal.href; item.removeAttribute('srcset'); });
    this.goTo(0);
  }
  goTo(index, animate = true) {
    this.index = Math.max(0, Math.min(index || 0, this.slides.length - 1));
    this.track.scrollTo({ left: this.index * this.track.clientWidth, behavior: animate && !this.reducedMotion.matches ? 'smooth' : 'auto' });
    if (!this.slides[this.index]?.hasAttribute('data-video-slide')) this.video?.pause();
  }
  updateGallery() {
    this.index = Math.max(0, Math.min(Math.round(this.track.scrollLeft / (this.track.clientWidth || 1)), this.slides.length - 1));
    this.thumbs.forEach(thumb => thumb.setAttribute('aria-pressed', String(Number(thumb.dataset.thumb) === this.index)));
    this.setText('[data-count]', String(this.index + 1));
    const previous = this.querySelector('[data-prev]');
    const next = this.querySelector('[data-next]');
    if (previous) previous.disabled = this.index === 0;
    if (next) next.disabled = this.index === this.slides.length - 1;
    if (!this.slides[this.index]?.hasAttribute('data-video-slide')) this.video?.pause();
  }
  async addItem() {
    if (this.busy || !this.variant?.available) return;
    this.busy = true;
    this.error.hidden = true;
    const variantId = this.variant.id;
    this.packInputs.concat(this.colourInputs).forEach(input => { input.disabled = true; });
    this.updateButtons();
    try {
      const response = await fetch(`${this.dataset.root}cart/add.js`, { method: 'POST', headers: { 'Content-Type': 'application/json', Accept: 'application/json' }, body: JSON.stringify({ items: [{ id: variantId, quantity: 1 }] }) });
      const data = await response.json();
      if (!response.ok) throw new Error(typeof data.description === 'string' ? data.description : this.words.error);
      this.setText('[data-cart-status]', this.words.added);
      const drawer = document.querySelector('fz-cart');
      if (drawer && customElements.get('fz-cart')) document.dispatchEvent(new CustomEvent('fz:cart-open'));
      else window.location.assign(`${this.dataset.root}cart`);
    } catch (error) {
      this.error.textContent = error.message || this.words.error;
      this.error.hidden = false;
      this.error.tabIndex = -1;
      this.error.focus({ preventScroll: false });
    } finally {
      this.busy = false;
      this.sync(false);
    }
  }
}
if (!customElements.get('fz-premium-product')) customElements.define('fz-premium-product', FzPremiumProduct);

  } catch(e) { console.error(e); }
})();
})();
